export class DeviceApplication {

    private appName: string;
    private appVersion: string;
    private lastConnection: string;

    constructor(appName?: string, appVersion?: string, lastConnection?: string) {
        this.appName = appName;
        this.appVersion = appVersion;
        this.lastConnection = lastConnection;
    }

    public get AppName() {
        return this.appName;
    }

    public get AppVersion() {
        return this.appVersion;
    }

    public get LastConnection() {
        return this.lastConnection;
    }

    public set AppName(appName) {
        this.appName = appName;
    }

    public set AppVersion(appVersion) {
        this.appVersion = appVersion;
    }

    public set LastConnection(lastConnection) {
        this.lastConnection = lastConnection;
    }
}
